import React from 'react';

function StandardSummaryLegend() {
  return (
    <div className="standard-summary-legend">
      <ol style={{ padding: 0 }}>
        <li>Suspected Serious Injury</li>
        <li>Suspected Minor Injury</li>
        <li>Possible Injury</li>
      </ol>
      <ul style={{ padding: 0 }}>
        <li>*     INJURY SEVERITY CODES</li>
        <li>**    PROPERTY DAMAGE ONLY</li>
      </ul>
    </div>
  )
}

export default StandardSummaryLegend;